import Phaser from "phaser";
import { Loader } from "../scenes/loader";
import { Chapter1Intro } from "../scenes/chapter1Intro";
import { Chapter1Scene1 } from "../scenes/chapter1Scene1";
import { Chapter1Scene2 } from "../scenes/chapter1Scene2";
import { Chapter2Intro } from "../scenes/chapter2Intro";
import { Chapter2Scene1 } from "../scenes/chapter2Scene1";
import { Chapter2Scene2 } from "../scenes/chapter2Scene2";
import { Chapter3Intro } from "../scenes/chapter3Intro";
import { Chapter3Scene1 } from "../scenes/chapter3Scene1";
import { Chapter3Scene2 } from "../scenes/chapter3Scene2";
import { Chapter4Intro } from "../scenes/chapter4Intro";
import { Chapter4Scene1 } from "../scenes/chapter4Scene1";
import { Chapter5Intro } from "../scenes/chapter5Intro";
import { Chapter5Scene1 } from "../scenes/chapter5Scene1";
import { Chapter5Scene2 } from "../scenes/chapter5Scene2";
import { Chapter6Intro } from "../scenes/chapter6Intro";
import { Chapter6Scene1 } from "../scenes/chapter6Scene1";
import { Chapter6Scene2 } from "../scenes/chapter6Scene2";
import { Chapter7Intro } from "../scenes/chapter7Intro";
import { Chapter7Scene1 } from "../scenes/chapter7Scene1";
import { Chapter7Scene2 } from "../scenes/chapter7Scene2";
import { Chapter7Scene3 } from "../scenes/chapter7Scene3";
import { Chapter8Intro } from "../scenes/chapter8Intro";
import { Chapter8Scene1 } from "../scenes/chapter8Scene1";
import { Chapter8Scene2 } from "../scenes/chapter8Scene2";
import { Chapter8Scene3 } from "../scenes/chapter8Scene3";
import { Chapter9Intro } from "../scenes/chapter9Intro";
import { Chapter9Scene1 } from "../scenes/chapter9Scene1";
import { Chapter9Scene2 } from "../scenes/chapter9Scene2";
import { Chapter10Intro } from "../scenes/chapter10Intro";
import { Chapter10Scene1 } from "../scenes/chapter10Scene1";
import { Chapter11Intro } from "../scenes/chapter11Intro";
import { Chapter11Scene1 } from "../scenes/chapter11Scene1";
import { SceneEvent } from "../events/sceneEvent";
import { HelpController } from "./helpController";
import { DialogController } from "./dialogController";
import { I18NController } from "./i18Controller";
import { PlayerEvent } from "../events/playerEvent";
import { PlayerController } from "./playerController";
import { I18NEvent } from "../events/i18nEvent";

import $ from "jquery";
import {Modal} from 'bootstrap';
import { MenuController } from "./menuController";
import { RessourcesController } from "./ressourcesController";
import { SoundController } from "./soundController";
import apiService from "@/services/apiService";
import { InterfaceEvent } from "../events/interfaceEvent";

class MainController {

	constructor() {
        if (!MainController.instance) {
            return MainController.instance;
        }

        MainController.instance = this;

        return this;
    }

	static init(env, token, debugScene)
	{

		this.env = env;
		this.token = token;
		this.debugScene = debugScene;

		this.gameInitialWidth = 1440;
		this.gameInitialHeight = 810;


		window.addEventListener( SceneEvent.SCENE_CREATE, function(e){
			console.log("SCENE_CREATE "+e.detail.name);
		});

		window.addEventListener( SceneEvent.SCENE_DESTROYED, function(e){
			console.log("SCENE_DESTROYED "+e.detail.name);
		});

		window.addEventListener( SceneEvent.SCENE_CHANGE, function(e){
			//console.log("SCENE_CHANGE "+e.detail.name);

			HelpController.clear();
			DialogController.clear();
		});


		window.addEventListener( I18NEvent.TRANSLATION_COMPLETE, ()=>{

			
				MainController.loadPlayerDatas();	

			
		}, this);

		I18NController.load('/datas/fr.json');



	}

	static getGameInitialSize()
	{
		return {
			width: this.gameInitialWidth,
			height: this.gameInitialHeight
		};
	}


	static loadPlayerDatas()
	{
		// ici on lance le chargement de la partie en cours
		window.addEventListener( PlayerEvent.LOADING_COMPLETE, function(e){
			
			if(MainController.debugScene == 'null')
			{
				MainController.home();
			}else
			{
				MainController.start();
			}
		}, this);
		
		PlayerController.init(this.token);


		this.config = {
			type: Phaser.AUTO,
			width: this.gameInitialWidth,
			height: this.gameInitialHeight,
			parent: 'game',
			dom: {
				createContainer: true
			},
			scale: {
				mode: Phaser.Scale.FIT,
				autoCenter: Phaser.Scale.CENTER_BOTH
			},
			physics: {
				default: 'arcade',
				arcade: {
					gravity: { y: 0 }
				}
			},
			scene: [ new Loader, new Chapter1Intro, new Chapter2Intro, new Chapter3Intro, new Chapter4Intro, new Chapter5Intro, new Chapter6Intro, new Chapter7Intro, new Chapter8Intro, new Chapter9Intro, new Chapter10Intro, new Chapter11Intro, new Chapter1Scene1, new Chapter1Scene2, new Chapter2Scene1, new Chapter2Scene2, new Chapter3Scene1, new Chapter3Scene2, new Chapter4Scene1, new Chapter5Scene1, new Chapter5Scene2, new Chapter6Scene1, new Chapter6Scene2, new Chapter7Scene1, new Chapter7Scene2, new Chapter7Scene3, new Chapter8Scene1, new Chapter8Scene2, new Chapter8Scene3, new Chapter9Scene1, new Chapter9Scene2, new Chapter10Scene1, new Chapter11Scene1 ]
		};

		
	}

	static openQuizStart()
	{
		this.startQuizModal = new Modal($('#startQuiz'));
		this.startQuizModal.show();

		window.dispatchEvent(new CustomEvent(InterfaceEvent.START_QUIZ_OPENED));
	}

	static openQuizEnd()
	{
		this.endQuizModal = new Modal($('#endQuiz'));
		this.endQuizModal.show();

		window.dispatchEvent(new CustomEvent(InterfaceEvent.END_QUIZ_OPENED));
	}	

	static completeQuizStart()
	{
		this.startQuizModal.hide();
		PlayerController.eraseDatas();
		PlayerController.eraseBookmark();
		MainController.start();
	}

	static completeQuizEnd()
	{
		this.endQuizModal.hide();
		MenuController.openCyberModal();
		
	}	


	static home()
	{
		this.startGameModal = new Modal($('#startGame'));
		this.confirmNewGameModal = new Modal($('#confirmNewGame'));
		
		this.startGameModal.show();

		$('#startGame .quitButton').click(function(){
			location.href = '/';
		});

		const recordedScene = PlayerController.getRecordedSceneName();

		if(!recordedScene)
		{
			$('#startGame .continueButton').hide();
			$('#startGame .startButton').click(()=>{
				this.startGameModal.hide();

				

				PlayerController.getMe().then(me => {
						if(me.activeKey)
						{
							MainController.openQuizStart();
						}else
						{
							$('#cyberButton').hide();
							PlayerController.eraseDatas();
							PlayerController.eraseBookmark();
							MainController.start();
						}
					}
				)
				.catch(error => {
				console.log(error)
						
					}
				);


			});
		}else
		{
		
			$('#startGame .continueButton').click(()=>{
				this.startGameModal.hide();
				

				PlayerController.getMe().then(me => {
					
						if(!me.activeKey)
						{
							$('#cyberButton').hide();
						}

						MainController.start();
					}
				)
				.catch(error => {
				console.log(error)
						
					}
				);
			});

			$('#startGame .startButton').click(()=>{
				this.confirmNewGameModal.show();
				
				$('#confirmNewGame .confirmNewGameButton').click(()=>{
					
					this.confirmNewGameModal.hide();
					this.startGameModal.hide();


					PlayerController.getMe().then(me => {
							if(me.activeKey)
							{
								MainController.openQuizStart();
							}else
							{
								$('#cyberButton').hide();
								PlayerController.eraseDatas();
								PlayerController.eraseBookmark();
								MainController.start();
							}
						}
					)
					.catch(error => {
					console.log(error)
							
						}
					);
					
				});
			});
		}
	}


	static start()
	{
		
		this.game = new Phaser.Game(this.config);

		MenuController.init();
		DialogController.init();
		HelpController.init();
		RessourcesController.init();
		RessourcesController.load('/datas/ressources/fr.json');
		SoundController.init();

		$(".messages").on("mousedown mouseup", function(e){
			// pour bloquer la navigation à la souris derrière les messages
			e.stopPropagation();
		});

	}

	static endGame()
	{
		PlayerController.getMe().then(me => {
				if(me.activeKey)
				{
					MainController.openQuizEnd();
				}else
				{
					MenuController.openCredits();
				}
			}
		)
		.catch(error => {
		console.log(error)
				
			}
		);
	}

	static stopPropagation(){
		$('*').on('mousedown mouseup touchstart touchend', function(event){
			event.stopPropagation();
		});
	}


	static getStartSceneName()
	{
		return PlayerController.getRecordedSceneName();
	}

	static registerChapter(sceneIntro)
	{
		PlayerController.registerChapter(sceneIntro.chapter, sceneIntro.title, sceneIntro.subtitle, sceneIntro.name);
	}


	static bookmarkChapter(sceneIntro)
	{
		this.currentChapter = sceneIntro.chapter;

		PlayerController.bookmarkSceneAndOpenChapter(this.currentChapter, sceneIntro.name);


	}

	static completeChapter(chapterId)
	{
		
		PlayerController.completeChapter(chapterId);

	}

	static setCurrentScene(scene)
	{
		this.currentScene = scene;

	}

	static getCurrentScene()
	{
		return this.currentScene;
	}

	static changeScene(name)
	{
		if(this.currentScene && (this.currentScene.name != name))
		{
			this.currentScene.goToScene(name, 	0);
		}
	}


	static getCurrentChapter()
	{
		return this.currentChapter;
	}


	static getToken()
	{
		return this.token;
	}

	static getFlirterURL()
	{
		return process.env.VUE_APP_FLIRTER_URL;
	}

	static isMobile()
	{
		var isMobile = false; //initiate as false
		// device detection
		if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
		    isMobile = true;
		}

		return isMobile;
	}

	static isChapterCompleted(chapter)
	{

		return PlayerController.isChapterCompleted(chapter);
		
	}


}
export { MainController };